const ValidationText = {
  invalidInput: "Invalid input",
  invalidUrl: "Invalid url",
  onlyLatinLetters:
    "Only latin letters, numbers, hyphens (-) and underscores (_) are allowed",
  onlyLatinLetters2: "Only latin letters, numbers, underscores(_) are allowed",
  onlyLatinLetters3:
    "Only latin letters, numbers and underscores(_) are allowed",
  onlyLatinLetters4:
    "Only latin letters, numbers, curly brackets ({}) and underscores(_) are allowed",
  onlyLatinLetters5:
    "Only latin letters, numbers, spaces, hyphens (-), underscores (_) and commas (,) are allowed",
  onlyLatin: "Only latin letters are allowed",
  invalidInputNumber: "Invalid input, only numbers are allowed",
  invalidPhoneNumber:
    "The field Phone must be a number with a minimum length of 7 and a maximum length of 20.",
  email: "Invalid email format",
  number: "Invalid number format",
  required: "This field is required",
  minLength1: "Min 1 symbols",
  minLength2: "Min 2 symbols",
  positiveNumber: "Only positive numbers are allowed",
  PercentageLess100: "Percentage must be less than 100",
  maxValue100: "Value must be less than 100",
  maxValue10000000: "Value must be less than 10 000 000",
  maxValue50: "Value must be less than 50",
  minLength3: "Min 3 symbols",
  maxLength3: "Max 3 symbols",
  incorrectSymbols: "Incorrect symbols",
  maxLength7: "Max 7 symbols",
  minLength6: "Min 6 symbols",
  minLength7: "Min 7 symbols",
  minLength8: "Min 8 symbols",
  maxLength5: "Max 5 symbols",
  maxLength20: "Max 20 symbols",
  maxLength50: "Max 50 symbols",
  maxLength75: "Max 75 symbols",
  maxLength2100: "Max 2100 symbols",
  maxLength125: "Max 125 symbols",
  maxLength128: "Max 128 symbols",
  maxLength255: "Max 255 symbols",
  maxLength500: "Max 500 symbols",
  maxLength1024: "Max 1024 symbols",
  maxLength2000: "Max 2000 symbols",
  maxLength5000: "Max 5000 symbols",
  maxAmount999999: "Max amount 999999.99",
  matchPassword: "Must matching with new password",
  shortPassword: "The password is too short",
  longPassword: "The password is too long",
  passwordMask:
    "Please use min 1 letter, 1 number, 1 special symbol, 1 upper case letter",
  usernameMask:
    "Only latin letters, numbers, hyphens (-) and underscores(_) are allowed",
  unique: "Field must be unique",
  otherContact:
    "Only latin letters, numbers, spaces, hyphens (-) and underscores(_) are allowed",
  integrationId: "Please select an Integration",
  minArray1: "Array length must be at least 1",
  tooLong: "URL too long",
  invalidIntegerNumber: "Please enter a whole number",
  invalidDecimalNumber: "Invalid decimal number",
  invalidAmount: "Amount must be a decimal number",
  spaceNotAllowed: "Spaces not allowed",
  invalidNumber: "Invalid number format ",
};

Object.freeze(ValidationText);
export default ValidationText;
